// Single source of truth for the Votely color system.
// Import from here instead of hardcoding hex values.

export interface MacroCellColor {
  code: string;
  hex: string;
  label: string;
  shortLabel: string;
  character: string;
  characterName: string;
}

export const MACRO_CELL_COLORS: MacroCellColor[] = [
  { code: 'EL-GA', hex: '#ff9ea0', label: 'Revolutionary Communism & State Socialism', shortLabel: 'Authoritarian Left', character: '/characters-v3/regions/EL-GA.svg', characterName: 'Lenin' },
  { code: 'EM-GA', hex: '#ff9fff', label: 'Authoritarian Statist Centrism', shortLabel: 'Authoritarian Center', character: '/characters-v3/regions/EM-GA.svg', characterName: 'Lee Kuan Yew' },
  { code: 'ER-GA', hex: '#9f9fff', label: 'Authoritarian Right & Corporatist Monarchism', shortLabel: 'Authoritarian Right', character: '/characters-v3/regions/ER-GA.svg', characterName: 'Francisco Franco' },
  { code: 'EL-GM', hex: '#ffcfa1', label: 'Democratic Socialism & Left Populism', shortLabel: 'Democratic Left', character: '/characters-v3/regions/EL-GM.svg', characterName: 'Bernie Sanders' },
  { code: 'EM-GM', hex: '#e5e5e5', label: 'Mixed-Economy Liberal Center', shortLabel: 'Centrist', character: '/characters-v3/regions/EM-GM.svg', characterName: 'Angela Merkel' },
  { code: 'ER-GM', hex: '#9ffffe', label: 'Conservative Capitalism & National Conservatism', shortLabel: 'Conservative Center', character: '/characters-v3/regions/ER-GM.svg', characterName: 'Margaret Thatcher' },
  { code: 'EL-GL', hex: '#9fff9e', label: 'Libertarian Socialism & Anarcho-Communism', shortLabel: 'Libertarian Left', character: '/characters-v3/regions/EL-GL.svg', characterName: 'Noam Chomsky' },
  { code: 'EM-GL', hex: '#d4fe9a', label: 'Social-Market Libertarianism', shortLabel: 'Libertarian Center', character: '/characters-v3/regions/EM-GL.svg', characterName: 'John Stuart Mill' },
  { code: 'ER-GL', hex: '#ffff9f', label: 'Anarcho-Capitalism & Ultra-Free-Market Libertarianism', shortLabel: 'Libertarian Right', character: '/characters-v3/regions/ER-GL.svg', characterName: 'Murray Rothbard' },
];

export const MACRO_CELL_HEX = MACRO_CELL_COLORS.map((c) => c.hex);

// 3x3 grid layout (row-major: auth top, lib bottom; left to right)
export const MACRO_CELL_GRID: string[][] = [
  ['#ff9ea0', '#ff9fff', '#9f9fff'],
  ['#ffcfa1', '#e5e5e5', '#9ffffe'],
  ['#9fff9e', '#d4fe9a', '#ffff9f'],
];

// Slider color: slate-blue gradient (not an ideology color)
export const SLIDER_BLUE = { light: '#93a8d1', dark: '#3b5998' };

// UI colors (matches globals.css tokens)
export const UI = {
  text: '#0f172a',
  textSecondary: '#475569',
  textMuted: '#94a3b8',
  surface: '#ffffff',
  surfaceAlt: '#f8fafc',
  border: '#e2e8f0',
  cta: '#0f172a',
  ctaHover: '#1e293b',
};
